(function () {'use strict';}());
angular.module("app").directive('rankView', function($document,$timeout) {
    return {
      restrict: 'A',
      templateUrl: 'views/rank.html',

      link:function($scope,element,attr)
      {
        var trace = angular.trace;

        $scope.playerRank = "N/A";
        $scope.rankClass = null;
        $timeout(initialize,0);


        $scope.complete = function(){
          $scope.setCurrentPage($scope.PAGE_COMPLETION);
        };

        function initialize(){
            $scope.playerRank = caluclateRank();
            $scope.rankClass = caluclateRankClass();
            var evt = {
                eventCategory: "GRTT: Game",
                eventLabel: "GRTT: Game Completion - Rank " + $scope.playerRank
            };
            gtag("event", 'GRTT: complete', evt);
        }

        function caluclateRank(){
        	if($scope.hoursRemaining <= 4) return "Rank 1";
          else if($scope.hoursRemaining <= 8) return "Rank 2";
          else if($scope.hoursRemaining <= 12) return "Rank 3";
          else if($scope.hoursRemaining <= 16) return "Rank 4";
          else if($scope.hoursRemaining <= 20) return "Rank 5";
        	else if($scope.hoursRemaining <= 24) return "Rank 6";
        	return "Rank 7";
        }
        function caluclateRankClass(){
          if($scope.hoursRemaining <= 4) return "r1";
          else if($scope.hoursRemaining <= 8) return "r2";
          else if($scope.hoursRemaining <= 12) return "r3";
          else if($scope.hoursRemaining <= 16) return "r4";
          else if($scope.hoursRemaining <= 20) return "r5";
          else if($scope.hoursRemaining <= 24) return "r6";
          return "r7";
        }



      }
    };
  });
